// ABOUTME: Helpers for the popover news tab - merging stockhub and warehouse news feeds.
// ABOUTME: Also extracts plain text from tiptap JSON for text-only previews.

export const mergeNewsFeeds = (stockhubItems = [], warehouseItems = []) => {
    const tagged = [
        ...stockhubItems.map((a) => ({ ...a, source: "stockhub" })),
        ...warehouseItems.map((a) => ({ ...a, source: "warehouse" })),
    ];
    return tagged.sort(
        (a, b) => new Date(b.publishedAt || b.createdAt || 0) - new Date(a.publishedAt || a.createdAt || 0)
    );
};

export const tiptapToText = (doc) => {
    if (!doc || typeof doc !== "object") return "";
    const walk = (node) => {
        if (!node) return "";
        if (node.type === "text") return node.text || "";
        const children = (node.content || []).map(walk).join("");
        return node.type === "paragraph" ? children + " " : children;
    };
    return walk(doc).replace(/\s+/g, " ").trim();
};
